import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { wrap as withStyle, stylesIf } from 'utils/styles'

import { Button } from 'components/patterns'

import ReduxNavigator from 'components/Navigator/ReduxNavigator'
import { DEFAULT_DRAWER_WIDTH } from 'utils/drawerConstants'

export default withStyle(
  ({ location }) => `
  display: flex;
  height: 100%;
  ${stylesIf(location.search.includes('history'), 'flex-direction: column;')}
`
)

export const StyledReduxNavigator = styled(ReduxNavigator)`
  width: ${DEFAULT_DRAWER_WIDTH - 40}px;
  flex-shrink: 0;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar,
  *::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track:vertical,
  *::-webkit-scrollbar-track:vertical {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:vertical,
  *::-webkit-scrollbar-thumb:vertical {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }
`

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'rotateIcon',
})`
  ${(props) =>
    stylesIf(
      !props.relative,
      `position: absolute;
       left: 335px;
       top: 20px;`
    )};

  && svg {
    ${(props) => stylesIf(props.rotateIcon, 'transform: rotate(180deg);')}
    width: 14px;
  }
`
export const HarnessButton = ({ text, ...props }) => (
  <StyledButton {...props}>{text}</StyledButton>
)

HarnessButton.propTypes = {
  text: PropTypes.string.isRequired,
  relative: PropTypes.bool,
  link: PropTypes.bool,
  onClick: PropTypes.func,
  rotateIcon: PropTypes.bool,
  iconProps: PropTypes.objectOf(PropTypes.string),
}
